import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import FirebaseAccountDetailsForm from './FirebaseAccountDetailsForm';

const FirebaseAccountDetails = ({
  page,
  onRegisterUser=f=>f,
  onGoBack,
  onNext,
  intl,
  content,
  marketing_referrers,
  marital_statuses,
  country_code,
  environment,
  transaction_email,
  territory_code,
  generateDetailsEnabled,
  showGenderField,
  requiredFields,
  criticalContracts,
  address,
  addressValidations,
  recaptchaSiteId,
  enable_firebase_authentication,
  authenticatedUser,
  hideRecaptcha
}) => {

  const thisPage = P.FIREBASE_DETAILS_PAGE

  return (
    <div>
      <Redirector this_page={thisPage} page={page}/>
      <FormHeader title={content.pages.firebase_account_details.title}/>
        <FirebaseAccountDetailsForm
          onRegisterUser={onRegisterUser}
          onGoBack={onGoBack}
          intl={intl}
          marketing_referrers={marketing_referrers}
          marital_statuses={marital_statuses}
          country_code={country_code}
          content={content}
          environment={environment}
          transaction_email={transaction_email}
          territory_code={territory_code}
          generateDetailsEnabled={generateDetailsEnabled}
          showGenderField={showGenderField}
          criticalContracts={criticalContracts}
          requiredFields={requiredFields}
          address={address}
          addressValidations={addressValidations}
          recaptchaSiteId={recaptchaSiteId}
          authenticatedUser={authenticatedUser}
          hideRecaptcha={hideRecaptcha}
        />
    </div>
  );
};

FirebaseAccountDetails.propTypes = {
  onRegisterUser: PropTypes.func,
  onRegisterFirebaseUser: PropTypes.func,
  onNext: PropTypes.func,
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object,
  marketing_referrers: PropTypes.array,
  country_code: PropTypes.string,
  environment: PropTypes.string
};

export default injectIntl(FirebaseAccountDetails);
